/* eslint-disable @typescript-eslint/no-magic-numbers */
import type { DeepPartial } from '@luna/utils-ts';
import type { ExportFeatureConfig, TransactionsFeatureConfig } from '@shared/transactions-config';

export const transactions: DeepPartial<TransactionsFeatureConfig> = {
    showReceiverAddress: true,
    showSenderAddress: true,
    stripLeadingZeros: true,
    showAccountPrefix: true,
    showBankCodeLabel: false,
    showOriginator: true,
    showExchangeDate: true,
    upcomingTimeModes: [3, 7, 14, 30],
    writtenItems: {
        addAllTypes: true,
    },
    showInstructionName: true,
    claims: {
        oidcReady: true,
        handover: {
            paramNames: [
                'client_id',
                'lang',
                'transaction_id',
                'startedFrom',
                'module',
                'caseType',
            ],
            paramValues: {
                startedFrom: 'PRODUCT_DASHBOARD',
                module: 'CAR',
                caseType: 'GSCCARD',
                salesChannel: 'GRG',
            },
        },
    },
    claimsFee: {
        oidcReady: true,
        handover: {
            paramNames: ['startedFrom', 'module', 'caseType', 'lang', 'transaction_id'],
            paramValues: {
                startedFrom: 'PRODUCT_DASHBOARD',
                module: 'POPLESC',
                caseType: 'GSCFID',
                salesChannel: 'GRG',
            },
        },
    },
    retrievals: {
        oidcReady: true,
        handover: {
            paramNames: ['lang', 'transaction_id', 'startedFrom', 'module', 'caseType'],
            paramValues: {
                startedFrom: 'PRODUCT_DASHBOARD',
                module: 'VCHOD',
                caseType: 'GSCPAYMENT',
                salesChannel: 'GRG',
            },
        },
    },
    searchForAmountInFulltextMode: false,
};

export const exportFeatures: DeepPartial<ExportFeatureConfig> = {
    fields: [
        { name: 'ownerAccountTitle', preselected: true, selectable: true },
        { name: 'ownerAccountNumber', preselected: true, selectable: true },
        { name: 'booking', preselected: true, selectable: true },
        { name: 'receiver', preselected: true, selectable: true },
        { name: 'amount', preselected: true, selectable: false },
        { name: 'currency', preselected: true, selectable: true },
        { name: 'symbolConstant', preselected: false, selectable: true },
        { name: 'symbolSpecific', preselected: false, selectable: true },
        { name: 'symbolVariable', preselected: false, selectable: true },
        { name: 'bookingTypeTranslation', preselected: false, selectable: true },
        { name: 'senderReference', preselected: false, selectable: true },
        { name: 'senderAddress', preselected: false, selectable: true },
        { name: 'receiverReference', preselected: false, selectable: true },
        { name: 'receiverAddress', preselected: false, selectable: true },
        { name: 'note', preselected: false, selectable: true },
        { name: 'category', preselected: false, selectable: true },
        { name: 'referenceNumber', preselected: false, selectable: true },
        { name: 'cardNumber', preselected: false, selectable: true },
        { name: 'cardLocation', preselected: false, selectable: true },
        { name: 'investmentName', preselected: false, selectable: true },
        { name: 'e2eReference', preselected: false, selectable: true },
        { name: 'virtualCardNumber', preselected: false, selectable: true },
        { name: 'virtualCardDevice', preselected: false, selectable: true },
        { name: 'instructionName', preselected: false, selectable: true },
    ],
    pdf: true,
    ofx: true,
};
